export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';


export const initialState = {
    open: false,
    message: '',
    severity: 'success', /** error | warning | info */
    duration: 2000
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SNACKBAR:
            return {
                open: true,
                message:  action.payload.message,
                severity: action.payload.severity,
                duration: action.payload.duration
            };
        case HIDE_SNACKBAR:
            return {
                open: false,
                message:  state.message,
                severity: state.severity,
                duration: state.duration
            }
        default:
            return initialState;
    }
};

